<template>
  <div class="page-box decision-box">
    <div class="decision-head">
      <div class="decision-head-left">飞行中故障后风险评估</div>
      <div class="decision-head-right">
        <div class="decision-head-bt" @click="historyErroyRecord">
          <img src="@/assets/images/yi.png" alt="" />历史记录
        </div>
        <div class="decision-head-bt active" @click="$router.push('/index')">
          <img src="@/assets/images/yi2.png" alt="" />回到首页
        </div>
      </div>
    </div>
    <div class="decision-page">
      <div class="Commitanalogdata-box">
        <div class="Commitanalogdata-right">
          <div class="fauldetails-ul">
            <div class="fauldetails-li">
              <div class="fauldetails-head">当前位置信息</div>
              <div class="fauldetails-bottom">
                <div class="fauldetails-laber">
                  <div class="fauldetails-left">latitude 纬度</div>
                  <div class="fauldetails-right">{{ handleVO.latitude }}</div>
                </div>
                <div class="fauldetails-laber">
                  <div class="fauldetails-left">longitude 经度</div>
                  <div class="fauldetails-right">{{ handleVO.longitude }}</div>
                </div>
                <div class="fauldetails-laber">
                  <div class="fauldetails-left">altitute 海拔高度</div>
                  <div class="fauldetails-right">{{ handleVO.height }}</div>
                </div>
                <div class="fauldetails-laber">
                  <div class="fauldetails-left">风量</div>
                  <div class="fauldetails-right">{{ handleVO.air }}</div>
                </div>
                <div class="fauldetails-laber">
                  <div class="fauldetails-left">温度</div>
                  <div class="fauldetails-right">
                    {{ handleVO.temperature }}
                  </div>
                </div>
                <div class="fauldetails-laber">
                  <div class="fauldetails-left">真航向</div>
                  <div class="fauldetails-right">
                    {{ handleVO.trueSailing }}
                  </div>
                </div>
                <div class="fauldetails-laber">
                  <div class="fauldetails-left">校正空速</div>
                  <div class="fauldetails-right">{{ handleVO.airspeed }}</div>
                </div>
              </div>
            </div>
            <div class="fauldetails-li">
              <div class="fauldetails-head">飞机重量信息</div>
              <div class="fauldetails-bottom">
                <div class="fauldetails-laber">
                  <div class="fauldetails-left">零燃油重量(单位:t)</div>
                  <div class="fauldetails-right">
                    {{ handleVO.zeroFuelWeight }}t
                  </div>
                </div>
                <div class="fauldetails-laber">
                  <div class="fauldetails-left">FUFEL 当前燃油重量(单位:t)</div>
                  <div class="fauldetails-right">
                    {{ handleVO.fuelWeight }}t
                  </div>
                </div>
                <div class="fauldetails-laber">
                  <div class="fauldetails-left">CG重心</div>
                  <div class="fauldetails-right">{{ handleVO.cg }}%</div>
                </div>
              </div>
            </div>
            <div class="fauldetails-li">
              <div class="fauldetails-head">备降机场信息</div>
              <div class="fauldetails-bottom">
                <div v-for="(item, index) in handleVO.airports">
                  <div class="fauldetails-laber">
                    <div class="fauldetails-left">
                      备降候选机场{{ index + 1 }}
                    </div>
                    <div class="fauldetails-right">{{ item.airport }}</div>
                  </div>
                  <div class="fauldetails-laber">
                    <div class="fauldetails-left">预计到达时间</div>
                    <div class="fauldetails-right">{{ item.arriveTime }}</div>
                  </div>
                  <div class="fauldetails-laber">
                    <div class="fauldetails-left">预计到达重量</div>
                    <div class="fauldetails-right">
                      {{ item.arriveWeight }} t
                    </div>
                  </div>
                  <div
                    class="fauldetails-line"
                    v-if="index + 1 !== handleVO.airports.length"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="Commitanalogdata-left">
          <div class="simulation-box">
            <div class="simulation-nav">
              <div
                v-for="tab in tabs"
                :key="tab.id"
                :class="active === tab.id ? 'active' : ''"
                @click="active = tab.id"
                class="simulation-li"
              >
                {{ tab.title }}
              </div>
            </div>
            <div class="simulation-page">
              <div class="upload-top">
                <!--                <div class="upload-left">视频采集</div>-->
                <div class="upload-left">视频信息</div>
                <div class="upload-left" v-if="iShowUpload">模拟机视频上传</div>
                <div class="upload-right" @click="downloadJSON">
                  <img src="@/assets/images/ss1.png" alt="" />下载JSON文件
                </div>
              </div>
              <div class="upload-box">
                <!-- <wss-player v-if="stream!==null" :title="this.playerStateIcon" :stream="stream" @reconnect="reconnect" @capture-picture="onClickPlayer" />-->
                <!-- <div class="operation-box"><div class="operation-time">{{activeCameraTitle}}</div><div class="operation-bt"><img src="@/assets/images/index/2.png"/>结束录制</div><div class="operation-bt active"><img src="@/assets/images/index/1.png"/>开始录制</div></div>-->
                <div v-for="tab in tabs" :key="tab.id">
                  <video controls v-if="tab.id === active && videoUrl" :key="tab.id">
                    <source :src="videoUrl" type="video/mp4" />
                  </video>
                </div>
                <div v-if="iShowUpload">
                  <div
                    v-for="tab in tabs"
                    :key="tab.id"
                    class="upload-box"
                    style="z-index: 30"
                    v-show="active === tab.id"
                  >
                    <div class="upload-img" slot="trigger">
                      <el-upload
                        class="upload-demo"
                        action="/api/upload/video/fault"
                        :headers="headers"
                        :before-upload="handleBeforeUpload"
                        :on-success="handleSuccess"
                        :on-error="handleError"
                      >
                        <img src="@/assets/images/ss2.png" alt="" />
                        <span>点击上传视频</span>
                      </el-upload>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
                    <div class="btt" v-if="handleVO.state==='S1'" :disabled="btnSubmitDisabled" @click="handleBtnSubmit" >提交</div>
          <!--          <div class="btt" style="background: #9e9e9e;pointer-events: none}" v-if="handleVO.state!=='S1'" >提交</div>-->
        </div>
      </div>
    </div>
    <div class="left-box">
      <el-dialog :visible.sync="dialogVisible">
        <div class="history-page">
          <div class="history-head">历史记录</div>
          <div class="history-input">
            <el-input
              @keyup.enter.native="changeHistoryList()"
              v-model="paramsHistory.flightNo"
              placeholder="请输入关键词搜索"
            ></el-input>
          </div>
          <div
            class="history-ul"
            @scroll="loadHistory($event)"
            v-if="historyList.length > 0"
          >
            <div
              class="history-li"
              v-for="(item, index) in historyList"
              :key="index"
            >
              <div class="history-top">
                <div class="history-text">
                  <div class="history-h">{{ item.fullFaultMessage }}</div>
                  <div class="history-p">{{ item.createTimeFormat }}</div>
                </div>
                <div class="history-bt" @click="goMalfunction(item)">
                  进入查看
                </div>
              </div>
              <div class="history-bottom">
                <div class="history-laber">
                  <div class="history-left">记录状态</div>
                  <div v-if="item.state === 'S0'" class="history-right active2">
                    {{ SocReviewEnum[item.state] }}
                  </div>
                  <div v-if="item.state === 'S1'" class="history-right active4">
                    {{ SocReviewEnum[item.state] }}
                  </div>
                  <div v-if="item.state === 'S2'" class="history-right active">
                    {{ SocReviewEnum[item.state] }}
                  </div>
                </div>
                <div class="history-laber">
                  <div class="history-left">记录编号</div>
                  <div class="history-right">{{ item.id }}</div>
                </div>
                <div class="history-laber">
                  <div class="history-left">飞机型号</div>
                  <div class="history-right">{{ item.planeType }}</div>
                </div>
                <div class="history-laber">
                  <div class="history-left">航班号</div>
                  <div class="history-right">{{ item.flightNo }}</div>
                </div>
                <div class="history-laber">
                  <div class="history-left">飞机编号</div>
                  <div class="history-right">{{ item.msn }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  findVOHandle,
  planeRiskRecordHandlePage,
  updataSimulatorHandle
} from "@/api/api";
import WssPlayer from "@/components/player/WssPlayer.vue";
import { getDeviceHikStreamVO } from "@/api/kecang";
import HikStreamVO from "@/components/player/HikStreamVO";
import dayjs from "dayjs";
import { getHikStreamVO } from "@/api/hik";
import HistoryListDialog from "@/views/Eventhandling/components/HistoryListDialog.vue";
export default {
  name: "decision",
  components: { WssPlayer },
  data() {
    return {
      dialogVisible: false,
      active: 1,
      param: {},
      handleVO: {
        simulationAir: { begin: "", end: "", title: "-" },
        simulationA: { begin: "", end: "", title: "-" },
        simulationB: { begin: "", end: "", title: "-" },
        simulationC: { begin: "", end: "", title: "-" },
        simulationAirVideo: { url: "", name: "", uname: "" },
        simulationAVideo: { url: "", name: "", uname: "" },
        simulationBVideo: { url: "", name: "", uname: "" },
        simulationCVideo: { url: "", name: "", uname: "" },
        airports: []
      },
      headers: { "x-token": window.localStorage.getItem("x-token") },

      queryHistory: {
        number: 1,
        limit: 10
      },
      paramsHistory: {
        flightNo: "CSN",
        orderBy: JSON.stringify([{ name: "id", direction: "DESC" }])
      },
      inputHistory: "",
      errorRecordHistoryList: [],
      isScrollHistory: true,
      stream: null
    };
  },
  created() {
    this.param.id = this.$route.params.id;
    console.log(this.param.id);
    this.getHandleVO();
    // this.playHikStream()
  },
  computed: {
    SocReviewEnum() {
      return { S0: "SOC确认信息", S1: "模拟机处理中", S2: "已反馈" };
    },
    tabs() {
      return [
        { id: 1, title: "空中故障模拟" },
        { id: 2, title: "A机场降落模拟" },
        { id: 3, title: "B机场降落模拟" },
        { id: 4, title: "C机场降落模拟" }
      ];
    },
    historyList() {
      console.log(`this.errorRecordHistoryList.length = ${this.errorRecordHistoryList.length}`);
      return this.errorRecordHistoryList;
    },
    playerStateIcon() {
      if (this.handleVO.state === "S2") {
        return "";
      }
      const { begin, end } = this.activeCamera;
      if (begin && end) {
        return ""; // 采集完成
      }
      if (begin) {
        return "icon-stop";
      } else {
        return "icon-start";
      }
    },
    activeCamera() {
      switch (this.active) {
        case 1:
          return this.handleVO.simulationAir; // 空中故障模拟
        case 2:
          return this.handleVO.simulationA; // A机场降落模拟
        case 3:
          return this.handleVO.simulationB; // B机场降落模拟
        case 4:
          return this.handleVO.simulationC; // C机场降落模拟
      }
      return null;
    },
    activeCameraTitle() {
      return this.activeCamera.title || "-";
    },
    btnSubmitDisabled() {
      // return [this.handleVO.simulationAir, this.handleVO.simulationA, this.handleVO.simulationB, this.handleVO.simulationC].some(camera => !(camera.begin && camera.end));
      return !(this.handleVO.state === "S1" && [this.simulationAirVideoUrl, this.simulationAVideo, this.simulationBVideo, this.simulationCVideo].some(video => !!video));
    },
    simulationAirVideoUrl() {
      if (this.handleVO.simulationAirVideo) {
        return this.handleVO.simulationAirVideo.url || "";
      }
      return "";
    },
    simulationAVideo() {
      if (this.handleVO.simulationAVideo) {
        return this.handleVO.simulationAVideo.url || "";
      }
      return "";
    },
    simulationBVideo() {
      if (this.handleVO.simulationBVideo) {
        return this.handleVO.simulationBVideo.url || "";
      }
      return "";
    },
    simulationCVideo() {
      if (this.handleVO.simulationCVideo) {
        return this.handleVO.simulationCVideo.url || "";
      }
      return "";
    },
    videoUrl() {
      const arrs = [this.simulationAirVideoUrl, this.simulationAVideo, this.simulationBVideo, this.simulationCVideo];
      const video = arrs[this.active - 1]
      return video || "";
    },
    iShowUpload() {
      return this.handleVO.state === 'S1' && !this.videoUrl
    }
  },
  methods: {
    initCamera(handleVO) {
      // if (!handleVO.simulationAir) {
      //   handleVO.simulationAir = {begin: '', end: '', title: '-'}
      // }
      // this.formatCameraTime(handleVO.simulationAir)
      //
      // if (!handleVO.simulationA) {
      //   handleVO.simulationA = {begin: '', end: '', title: '-'}
      // }
      // this.formatCameraTime(handleVO.simulationA)
      //
      // if (!handleVO.simulationB) {
      //   handleVO.simulationB = {begin: '', end: '', title: '-'}
      // }
      // this.formatCameraTime(handleVO.simulationB)
      //
      // if (!handleVO.simulationC) {
      //   handleVO.simulationC = {begin: '', end: '', title: '-'}
      // }
      // this.formatCameraTime(handleVO.simulationC)
      // return handleVO
    },
    /**
     *
     * @param camera {object}
     */
    formatCameraTime(camera) {
      const arrs = ["", ""];
      if (camera.begin) {
        arrs[0] = camera.begin
          .substring(8)
          .replace(
            /(\d{2})(\d{2})(\d{2})/,
            (match, h, m, s) => `${h}:${m}:${s}`
          );
      }
      if (camera.end) {
        arrs[1] = camera.end
          .substring(8)
          .replace(
            /(\d{2})(\d{2})(\d{2})/,
            (match, h, m, s) => `${h}:${m}:${s}`
          );
      }
      camera.title = `${arrs[0]}-${arrs[1]}`;
    },
    async getHandleVO() {
      const res = await findVOHandle(this.param);
      if (res.code === "A00000") {
        const { simulationAirVideo, simulationAVideo, simulationBVideo, simulationCVideo, ...args } = res.data[0];
        this.handleVO = {
          ...args,
          simulationAirVideo: simulationAirVideo || { url: "", name: "", uname: "" },
          simulationAVideo: simulationAVideo || { url: "", name: "", uname: "" },
          simulationBVideo: simulationBVideo || { url: "", name: "", uname: "" },
          simulationCVideo: simulationCVideo || { url: "", name: "", uname: "" }
        };
      }
    },
    async handleBtnSubmit() {
      if (this.btnSubmitDisabled) {
        this.$message.error("请至少上传一个模拟机视频后再继续操作");
        return;
      }
      this.handleVO.state = "S2";
      const res = await updataSimulatorHandle(this.handleVO);
      if (res.code === "A00000") {
        this.$message.success("提交成功");
      } else {
        this.$message.error(res.message);
      }
    },
    handleBeforeUpload(file) {
      const isMp4 = file.type === "video/mp4";
      if (!isMp4) {
        this.$message.error("只能上传 MP4 格式的视频文件");
      }
      return isMp4;
    },
    handleSuccess(response, file) {
      this.$nextTick(() => {
        switch (this.active) {
          case 1:
            this.handleVO.simulationAirVideo = response.data[0];
            break;
          case 2:
            Object.assign(this.handleVO.simulationAVideo, response.data[0]);
            break;
          case 3:
            this.handleVO.simulationBVideo = response.data[0];
            break;
          case 4:
            this.handleVO.simulationCVideo = response.data[0];
            break;
        }
      });
    },
    handleError(error) {},
    async planeRiskRecordHistory() {
      this.isScrollHistory = false;
      const res = await planeRiskRecordHandlePage(
        this.queryHistory,
        this.paramsHistory
      );
      if (res.code === "A00000" && res.data.length) {
        this.errorRecordHistoryList.push(...res.data);
        this.isScrollHistory = true;
        if (res.data.length < 10) {
          this.isScrollHistory = false;
          //  this.$message.info('已全部加载完')
        }
      } else {
        this.isScrollHistory = false;
      }
    },
    loadHistory(e) {
      const sHeight = e.target.scrollHeight;
      const sTop = e.target.scrollTop;
      const cHeight = e.target.clientHeight;
      if (sTop + cHeight + 50 >= sHeight && this.isScrollHistory) {
        this.morePageHistory();
      }
    },
    morePageHistory() {
      this.queryHistory.number++;
      this.planeRiskRecordHistory();
    },
    historyErroyRecord() {
      // this.queryHistory.number = 1;
      // this.errorRecordHistoryList = [];
      this.planeRiskRecordHistory();
      this.dialogVisible = true;
    },
    changeHistoryList() {
      if (this.paramsHistory.flightNo === "") {
        this.paramsHistory.flightNo = null;
      }
      this.errorRecordHistoryList = [];
      this.planeRiskRecordHistory();
    },
    parseLatLon(str) {
      const firstChar = str.charAt(0); // 获取方向字符串的最后一个字符
      let latlon = 0; // 返回值
      if (firstChar === "E" || firstChar === "W") {
        // 处理经度
        const value = Number(str.substring(1, str.length));
        if (firstChar === "E") {
          latlon += value;
        } else {
          latlon -= value;
        }
      } else if (firstChar === "N" || firstChar === "S") {
        // 处理纬度
        const value = Number(str.substring(1, str.length));
        if (firstChar === "N") {
          latlon += value;
        } else {
          latlon -= value;
        }
      }
      return latlon;
    },
    parseTemperature(str) {
      const firstChar = str.charAt(0); // 获取温度字符串的一个字符
      let temperature = 0; // 返回值
      const value = Number(str.substring(1, str.length));
      //温度首字母为M为零下 P为零上
      if (firstChar === "M") {
        temperature -= value;
      } else {
        temperature += value;
      }
      return temperature;
    },
    goMalfunction(item) {
      this.$router.push(`/simulator2/${item.id}`);
    },
    downloadJSON() {
      const jsonName = {
        1: "Information.json",
        2: "InformationA.json",
        3: "InformationB.json",
        4: "InformationC.json"
      };
      var str = JSON.stringify(this.toJSON());
      const blob = new Blob([str], { type: "application/json;charset=utf-8" });
      const href = URL.createObjectURL(blob);
      const alink = document.createElement("a");
      alink.style.display = "none";
      alink.download = jsonName[this.active]; // 下载后文件名
      alink.href = href;
      document.body.appendChild(alink);
      alink.click();
      document.body.removeChild(alink); // 下载完成移除元素
      URL.revokeObjectURL(href); // 释放掉blob对象
    },
    toJSON() {
      const json = {
        version: 1,
        allow_edit: true,
        plugins: [],
        panes: [
          {
            title: "实时视频流",
            width: 1,
            row: { "3": 1, "4": 5, "5": 5 },
            col: { "3": 1, "4": 1, "5": 2 },
            col_width: 3,
            widgets: [
              {
                type: "picture",
                settings: {
                  src: "/screenshot?type=jpg&stream=true",
                  stream: true,
                  refresh: 0,
                  height: 9
                }
              }
            ]
          },
          {
            title: "重定位至当前位置",
            width: 1,
            row: { "3": 21, "4": 25, "5": 1, "6": 1, "7": 1 },
            col: { "3": 1, "4": 1, "5": 1, "6": 1, "7": 1 },
            col_width: 1,
            widgets: [
              {
                type: "ptree_widget",
                settings: {
                  title: "飞机当前位置",
                  type: "checkbox",
                  value: [],
                  defaults: [
                    {
                      path: "/sim/presets/longitude-deg",
                      value: `${this.parseLatLon(this.handleVO.longitude)}`,
                      description: "飞机当前经度"
                    },
                    {
                      path: "/sim/presets/latitude-deg",
                      value: `${this.parseLatLon(this.handleVO.latitude)}`,
                      description: "飞机当前纬度"
                    },
                    {
                      path: "/sim/presets/altitude-ft",
                      value: `${parseInt(this.handleVO.height) * 100}`,
                      description: "飞机当前高度"
                    },
                    {
                      path: "/environment/wind-from-heading-deg",
                      value: `${parseInt(this.handleVO.air.substring(0, 3))}`,
                      description: "风向"
                    },
                    {
                      path: "/environment/wind-speed-kt",
                      value: `${parseInt(this.handleVO.air.substring(3, 6))}`,
                      description: "风速"
                    },
                    {
                      path: "/environment/temperature-degc",
                      value: `${this.parseTemperature(
                        this.handleVO.temperature
                      )}`,
                      description: "温度"
                    },
                    {
                      path: "/sim/presets/heading-deg",
                      value: `${this.handleVO.trueSailing}`,
                      description: "航向"
                    },
                    {
                      path: "/sim/presets/airspeed-kt",
                      value: `${this.handleVO.airspeed}`,
                      description: "空速"
                    },
                    { path: "/systems/start-up-on-start", value: "true" }
                  ],
                  command: "reposition",
                  height: 0
                }
              },
              {
                type: "ptree_widget",
                settings: {
                  title: "飞机重量设置",
                  type: "checkbox",
                  value: [],
                  defaults: [
                    {
                      path: "/fdm/nfl/MAS/FUN_IN/REIZFW-kg",
                      value: `${parseFloat(this.handleVO.zeroFuelWeight) *
                        1000}`,
                      description: "无燃油重量"
                    },
                    {
                      path: "/fdm/nfl/MAS/FUN_IN/REIMAS0-kg",
                      value: `${(
                        (parseFloat(this.handleVO.zeroFuelWeight) +
                          parseFloat(this.handleVO.fuelWeight)) *
                        1000
                      ).toFixed(0)}`,
                      description: "总重GW=ZFW+FUEL"
                    },
                    {
                      path: "/fdm/nfl/MAS/FUN_IN/REICG-wu",
                      value: `${this.handleVO.cg}`,
                      description: "重心"
                    },
                    {
                      path: "/fdm/nfl/FUEL-CG/FUN_IN/REFMTC-kg",
                      value: `${parseFloat(this.handleVO.fuelWeight) * 1000}`,
                      description: "燃油量"
                    }
                  ],
                  command: "设置重量、重心",
                  height: 5
                }
              }
            ]
          },
          {
            title: "重定位至备降机场",
            width: 1,
            row: { "3": 21, "4": 25, "5": 13, "6": 13, "7": 13 },
            col: { "3": 2, "4": 2, "5": 1, "6": 1, "7": 1 },
            col_width: 1,
            widgets: (this.handleVO.airports || []).map((row, idx) => ({
              type: "ptree_widget",
              settings: {
                title: `备降${row.airport}机场`,
                type: "checkbox",
                value: [],
                defaults: [
                  {
                    path: "/sim/presets/airport-id",
                    value: row.airport,
                    description: "备降机场四字代码"
                  },
                  { path: "/sim/presets/airport-requested", value: "true" },
                  {
                    path: "/sim/presets/airspeed-kt",
                    value: "160",
                    description: "预设空速"
                  },
                  {
                    path: "/sim/presets/altitude-ft",
                    value: "1500",
                    description: "预设高度"
                  },
                  { path: "/sim/presets/onground", value: "false" },
                  { path: "/sim/presets/trim", value: "true" },
                  { path: "/sim/presets/longitude-deg", value: "-9999" },
                  { path: "/sim/presets/latitude-deg", value: "-9999" },
                  { path: "/sim/presets/runway-requested", value: "false" },
                  {
                    path: "/fdm/nfl/MAS/FUN_IN/REIMAS0-kg",
                    value: `${parseFloat(row.arriveWeight) * 1000}`
                  }
                ],
                command: "reposition",
                height: idx === 0 ? 5 : 0
              }
            }))
          },
          {
            title: "重定位至起飞跑道",
            width: 1,
            row: { "0": 1, "3": 21, "4": 25, "5": 19, "6": 1, "7": 1, "9": 1 },
            col: { "0": 0, "3": 3, "4": 3, "5": 5, "6": 2, "7": 2, "9": 2 },
            col_width: 1,
            widgets: [
              {
                type: "ptree_widget",
                settings: {
                  title: "",
                  type: "checkbox",
                  value: [
                    'datasources["presets"]["children"][19]',
                    'datasources["presets"]["children"][20]'
                  ],
                  defaults: [
                    { path: "/sim/presets/longitude-deg", value: "-9999" },
                    { path: "/sim/presets/latitude-deg", value: "-9999" },
                    { path: "/sim/presets/airspeed-kt", value: "0" },
                    { path: "/sim/presets/offset-distance-nm", value: "0" },
                    { path: "/sim/presets/altitude-ft", value: "0" },
                    { path: "/sim/presets/onground", value: "true" }
                  ],
                  command: "reposition",
                  height: 5
                }
              }
            ]
          },
          {
            title: "重定位至任意位置",
            width: 1,
            row: { "0": 1, "3": 33, "4": 1, "5": 1, "6": 1, "7": 1 },
            col: { "0": 0, "3": 3, "4": 4, "5": 5, "6": 1, "7": 1 },
            col_width: 1,
            widgets: [
              {
                type: "ptree_widget",
                settings: {
                  title: "",
                  type: "checkbox",
                  value: [
                    'datasources["presets"]["children"][0]',
                    'datasources["presets"]["children"][1]',
                    'datasources["presets"]["children"][2]',
                    'datasources["presets"]["children"][3]',
                    'datasources["presets"]["children"][7]'
                  ],
                  command: "reposition",
                  height: 8
                }
              }
            ]
          },
          {
            title: "说明",
            width: 1,
            row: { "3": 51, "4": 1, "5": 1, "6": 19, "7": 19, "9": 19 },
            col: { "3": 1, "4": 1, "5": 2, "6": 2, "7": 2, "9": 2 },
            col_width: 3,
            widgets: [
              {
                type: "text_widget",
                settings: {
                  size: "small",
                  value: "OEI -- B787-8  CSN343  B2737 CSN-MEL",
                  animate: true
                }
              }
            ]
          },
          {
            title: "Weight & Balance",
            width: 1,
            row: { "3": 21, "4": 37, "5": 25, "7": 21 },
            col: { "3": -26, "4": 1, "5": 1, "7": -26 },
            col_width: 4,
            widgets: [
              {
                type: "sparkline",
                settings: {
                  title: "",
                  value: [
                    'datasources["nfl"]["children"][5]["children"][0]["children"][16]["value"]',
                    'datasources["nfl"]["children"][2]["children"][0]["children"][2]["value"]',
                    'datasources["nfl"]["children"][5]["children"][0]["children"][13]["value"]',
                    'datasources["nfl"]["children"][5]["children"][0]["children"][47]["value"]'
                  ],
                  include_legend: false,
                  legend: "CG, FUEL, GW, ZFW"
                }
              }
            ]
          }
        ],
        datasources: [
          {
            name: "presets",
            type: "Simulator RESTful API",
            settings: {
              url: "/json/sim/presets?d=5",
              refresh: 3,
              method: "GET",
              name: "presets"
            }
          },
          {
            name: "nfl",
            type: "Simulator RESTful API",
            settings: { url: "/json/fdm/nfl?d=5", refresh: 3, method: "GET" }
          },
          {
            name: "position",
            type: "Simulator RESTful API",
            settings: { url: "/json/position?d=3", refresh: 1, method: "GET" }
          },
          {
            name: "velocities",
            type: "Simulator RESTful API",
            settings: { url: "/json/velocities?d=5", refresh: 1, method: "GET" }
          }
        ],
        columns: 5
      };
      return json;
    },
    // 获取视频播放地址
    async playHikStream() {
      try {
        this.stream = await getHikStreamVO();
      } catch (e) {
        // this.$message.error(e)
      }
    },
    // 播放断开重连
    reconnect({ key, protocol }) {
      console.log({ key, protocol });
      this.playHikStream();
    }
    // // 点击
    // onClickPlayer() {
    //   if (this.handleVO.state === 'S2') {
    //     return
    //   }
    //   const camera = this.activeCamera
    //   const {begin, end} = camera
    //   if (begin && end) {
    //     return // 采集完成
    //   }
    //   const now = dayjs().add(8, 'h')
    //   if (begin) {
    //     this.$message.warning(`停止采集模拟机画面：${now.format('HH:mm:ss')}`)
    //     camera.end = now.add(1, 'm').format('YYYYMMDDHHmmss') // 录制存储有延时，这里结束时间多加一分钟
    //     camera.cameraIndexCode = this.cameraIndexCode
    //     this.playHikStream()
    //   } else {
    //     this.$message.success(`开始采集模拟机画面：${now.format('HH:mm:ss')}`)
    //     camera.begin = now.format('YYYYMMDDHHmmss')
    //     camera.end = ''
    //   }
    //   this.formatCameraTime(camera)
    // }
  }
};
</script>

<style lang="less" scoped>
.Commitanalogdata-right {
  width: 450px;
  flex: initial;
  margin-right: 24px;

  .fauldetails-ul {
    padding: 0;
  }
}

.fauldetails-laber {
  margin-bottom: 15px !important;
}

.fauldetails-line {
  height: 1px;
  width: 100%;
  background: #1d2437;
  margin-bottom: 10px;
}

.btt {
  height: 44px;
  color: rgba(255, 255, 255, 0.87);
  background: #1f60c1;
  border-radius: 8px;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 24px;
  cursor: pointer;
}

.upload-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;

  .upload-left {
    font-size: 20px;
  }

  .upload-right {
    height: 36px;
    border: 0.5px solid rgba(255, 255, 255, 0.6);
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    padding: 0 12px;
    cursor: pointer;

    img {
      width: 14px;
      margin-right: 4px;
    }
  }
}

.simulation-page {
  display: block;
  position: relative;

  video {
    height: 42vw;
  }

  .upload-box {
    position: absolute;
    height: 42vw;
    width: 100%;
    border: 0.5px dashed rgba(255, 255, 255, 0.6);
    border-radius: 8px;

    .upload-img {
      cursor: pointer;

      img {
        width: 44px;
        margin-bottom: 12px;
      }

      span {
        display: block;
        font-size: 14px;
        opacity: 0.6;
      }
    }
  }
}

.Commitanalogdata-left {
  flex: 1;
  width: auto;
  margin-right: 0;
}

.parameter-li {
  width: calc(33.3% - 16px);
}

.fauldetails-bt-box {
  position: relative;

  .fauldetails-bt {
    border: 1px solid rgba(255, 255, 255, 0.6);
    color: rgba(255, 255, 255, 0.6);
  }

  .fauldetails-bt.active {
    border: 1px solid #1f60c1;
    color: #fff;
  }
}

.decision-page {
  display: block;
}

.fauldetails-li {
  background: #262d40;
}

/deep/ .left-box .el-dialog__wrapper {
  display: block;

  .el-dialog {
    border-radius: 0;
  }
}

/deep/ .left-box .el-dialog {
  margin: 0 !important;
  background: #262d40;
  height: 100vh;
  width: 600px;

  .el-dialog__header {
    padding: 0;
  }

  .el-dialog__body {
    padding: 0;
    color: #fff;
  }

  .el-dialog__headerbtn .el-dialog__close {
    color: #fff;
    font-size: 20px;
  }

  .el-dialog__headerbtn {
    top: 22px;
  }
}

.history-head {
  padding: 24px 16px;
  font-size: 24px;
  text-align: left;
  line-height: 20px;
}

.history-input {
  background: #131b33;
  width: calc(100% - 32px);
  margin: auto;
  height: 45px;
  display: flex;
  align-items: center;
  border-radius: 8px;

  /deep/ .el-input__inner {
    background: none;
    color: #fff;
  }
}

.history-bottom {
  padding: 24px;

  .history-laber:last-child {
    margin-bottom: 0;
  }

  .history-laber {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;

    .history-left {
      opacity: 0.87;
      font-size: 14px;
    }

    .history-right {
      opacity: 0.9;
      font-size: 16px;
    }

    .history-right.active {
      color: #e07073;
    }

    .history-right.active2 {
      color: #8ebf86;
    }

    .history-right.active3 {
      color: #eba967;
    }

    .history-right.active4 {
      color: #2769ec;
    }
  }
}

.operation-box {
  position: absolute;
  height: 100%;
  z-index: 999;
  right: 0;
  top: 0;
  width: 1px;

  .operation-time {
    top: 20px;
    right: 20px;
    position: absolute;
    font-size: 24px;
    color: #000;
    font-weight: bold;
    width: 300px;
    text-align: right;
    -webkit-text-stroke: 1px #fff;
  }

  .operation-bt.active {
    right: 170px;
  }

  .operation-bt {
    position: absolute;
    width: 130px;
    bottom: 20px;
    right: 20px;
    background: #164b9a;
    border: 1px solid #164b9a;
    height: 40px;
    cursor: pointer;
    border-radius: 5px;
    display: flex;
    justify-content: center;
    font-size: 14px;
    color: #fff;
    align-items: center;

    img {
      width: 16px;
      margin-right: 8px;
    }
  }
}

.history-ul {
  padding: 16px;
  border-top: 1px solid #171e2f;
  margin-top: 20px;
  height: calc(100vh - 136px);
  padding-bottom: 0;
  box-sizing: border-box;
  overflow: auto;

  .history-li {
    background: #393f52;
    border: 1px solid #525f89;
    border-radius: 16px;
    margin-bottom: 16px;

    .history-top {
      display: flex;
      padding: 24px;
      justify-content: space-between;
      border-bottom: 1px solid #000000;

      .history-text {
        text-align: left;
        width: 370px;

        .history-h {
          font-size: 16px;
          color: rgba(255, 255, 255, 0.87);
          margin-bottom: 10px;
        }

        .history-p {
          color: rgba(255, 255, 255, 0.7);
          font-size: 12px;
        }
      }

      .history-bt {
        background: #4e5569;
        border-radius: 8px;
        font-size: 14px;
        cursor: pointer;
        padding: 0 20px;
        height: 34px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/simulator2/simulator2.vue